




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import AppMessage from '../../core/models/appMessage';
import { Stripe, StripeElements, StripeElement, Card, StripeCardElement, loadStripe } from '@stripe/stripe-js';
import environment from '@/environment';

@Component
export default class AddCard extends Vue {
  @Prop() public openModal!: boolean;
  public addCardBtnLoading: boolean = false;
  private stripeApi!: Stripe;
  private stripeElements!: StripeElements;
  private card!: StripeCardElement;
  private cardError: string = '';

  constructor() {
    super();
  }

  public async created() {
    const stripe = await loadStripe(environment.stripeKey);
    if (stripe) {
      this.stripeApi = stripe;
    } else {
      throw Error('failed to load stripe');
    }
    this.stripeElements = this.stripeApi.elements();

    this.createCardElement();
  }

  public closeModal() {
    this.$emit('closeAddCardModal');
  }

  public createCardElement() {
    this.card = this.stripeElements.create('card');
    this.card.update({ hidePostalCode : true });
    this.card.mount('#card-element');
    this.card.on('change', (event) => {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = '';
      }
    });
  }

  public addNewCard() {
    this.stripeApi.createToken(this.card).then(async (result) => {
      const token = result.token!.id;
      this.$emit('addNewCard', token);
    });
  }
}
